/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import dayjs from "dayjs";
import { makeNiceText } from "utils/formatters";

const estadoConfig = {
  Pendiente: { color: "#fadbd8", label: "Pendiente" },
  EnProceso: { color: "#cbc8f7", label: "En proceso" },
};

const getRowsOT = (data) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      const { color, label } = estadoConfig[item.estado] || { color: "default", label: "Desconocido" };
      rows.push({
        hora: (
          <SoftBox onClick={(e) => handleOpenMenu(e, item)} sx={{
            cursor: item.estado != "Finalizado" && item.estado != "Anulado" ? "pointer" : "default",
          }}>
            <SoftTypography verticalAlign="text-top" variant="h4" fontWeight="bold" color="dark">
              {dayjs(item?.createdAt).format("HH:mm") || "Sin fecha de entrega"}
            </SoftTypography>
          </SoftBox>
        ),
        producto: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="h4" fontWeight="bold" color="dark">
              {item?.producto ? makeNiceText(item?.producto.nombre) : "Sin datos"}
            </SoftTypography>
          </SoftBox>
        ),
        cantidad: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="h4">
              {item?.cantPorciones ? item?.cantPorciones : "Sin datos"}
            </SoftTypography>
          </SoftBox>
        ),
        observaciones: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="h4" fontWeight="medium">
              {item?.observaciones ? item?.observaciones : "-"}
            </SoftTypography>
          </SoftBox>
        ),
        estado: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="h4" fontWeight="medium">
              {item?.estado ? label : "-"}
            </SoftTypography>
          </SoftBox>
        ),
        accion: (
          <SoftBox mr={2} display="flex" flexDirection="row">
            <Tooltip title="Borrar" placement="top">
              <Icon
                fontSize="small"
                sx={{
                  cursor: "pointer",
                }}
                onClick={() => {
                  console.log(item);
                }}
              >
                cancel
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
        color: color,
        hasBorder: true,
      });
    });
  }

  return rows;
};

const columnsOT = [
  { name: "hora", desc: "hora", align: "center", width: "1%", noOrder: true },
  { name: "producto", desc: "Descripción", align: "left" },
  { name: "cantidad", desc: "Cantidad", align: "center", noOrder: true },
  { name: "observaciones", desc: "Comentario", align: "left", noOrder: true },
  { name: "estado", desc: "Estado", align: "center", noOrder: true },
];

export default { columnsOT, getRowsOT };
